(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["14Quiz"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function reduceMotionOK() {
      return !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    }

    function retrigger(el) {
      if (!el) return;
      el.classList.remove('is-animating');
      void el.offsetWidth;
      el.classList.add('is-animating');
    }

    function initFinder(root) {
      var sectionId = root.getAttribute('data-hinalya-finder');
      var dataEl = document.getElementById('hinalya-finder-data-' + sectionId);
      if (!dataEl) return;

      var data;
      try {
        data = JSON.parse(dataEl.textContent);
      } catch (e) {
        return;
      }

      var STEPS = 3;
      var panels = {
        intro: root.querySelector('[data-hf-panel="intro"]'),
        quiz: root.querySelector('[data-hf-panel="quiz"]'),
        result: root.querySelector('[data-hf-panel="result"]')
      };
      var startBtn = root.querySelector('[data-hf-start]');
      var backBtn = root.querySelector('[data-hf-back]');
      var restartBtn = root.querySelector('[data-hf-restart]');
      var questionEl = root.querySelector('[data-hf-question]');
      var progressLabelEl = root.querySelector('[data-hf-progress-label]');
      var progressFillEl = root.querySelector('[data-hf-progress-fill]');
      var progressTrackEl = root.querySelector('[data-hf-progress-track]');
      var resultEl = root.querySelector('[data-hf-result]');

      var state = { step: 0, q1: null, q2: null };

      function showPanel(name) {
        Object.keys(panels).forEach(function (key) {
          var panel = panels[key];
          if (!panel) return;
          panel.hidden = key !== name;
        });
      }

      function updateProgress(step) {
        var label = data.progressLabel
          .replace('{n}', step)
          .replace('{total}', STEPS);
        if (progressLabelEl) progressLabelEl.textContent = label;
        if (progressFillEl) progressFillEl.style.width = Math.round((step / STEPS) * 100) + '%';
        if (progressTrackEl) progressTrackEl.setAttribute('aria-valuenow', step);
        if (backBtn) backBtn.hidden = step <= 1;
      }

      function focusHeading(el) {
        if (!el) return;
        el.setAttribute('tabindex', '-1');
        el.focus({ preventScroll: true });
      }

      function renderQuestion(questionData, onSelect, selectedId) {
        questionEl.innerHTML = '';

        var heading = document.createElement('h3');
        heading.className = 'hinalya-finder__question-text';
        heading.textContent = questionData.text;
        questionEl.appendChild(heading);

        var list = document.createElement('div');
        list.className = 'hinalya-finder__options';

        questionData.options.forEach(function (option) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'hinalya-finder__option';
          btn.textContent = option.label;
          var isSelected = selectedId === option.id;
          btn.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
          if (isSelected) btn.classList.add('is-selected');
          btn.addEventListener('click', function () {
            onSelect(option);
          });
          list.appendChild(btn);
        });

        questionEl.appendChild(list);
        if (reduceMotionOK()) retrigger(questionEl);
        focusHeading(heading);
      }

      function goToQ1(preserveAnswers) {
        if (!preserveAnswers) {
          state = { step: 1, q1: null, q2: null };
        } else {
          state.step = 1;
        }
        updateProgress(1);
        renderQuestion(data.q1, selectQ1, state.q1);
        showPanel('quiz');
      }

      function selectQ1(option) {
        state.q1 = option.id;
        state.step = 2;
        updateProgress(2);
        renderQuestion(data.q2[option.id], selectQ2, null);
      }

      function selectQ2(option) {
        state.q2 = option.id;
        state.step = 3;
        updateProgress(3);
        renderQuestion(data.q3, selectQ3, null);
      }

      function selectQ3(option) {
        var resultKey = option.id === 'multi' ? 'multi' : state.q2;
        showResult(resultKey);
      }

      function goBack() {
        if (state.step === 3 && state.q1) {
          state.step = 2;
          updateProgress(2);
          renderQuestion(data.q2[state.q1], selectQ2, state.q2);
        } else if (state.step === 2) {
          state.step = 1;
          updateProgress(1);
          renderQuestion(data.q1, selectQ1, state.q1);
        }
      }

      function showResult(key) {
        var result = data.results[key];
        if (!result) return;
        resultEl.innerHTML = '';

        if (result.image) {
          var mediaWrap = document.createElement('div');
          mediaWrap.className = 'hinalya-finder__result-media';
          var img = document.createElement('img');
          img.src = result.image;
          img.alt = result.imageAlt || '';
          img.loading = 'lazy';
          mediaWrap.appendChild(img);
          resultEl.appendChild(mediaWrap);
        }

        if (result.emoji) {
          var emojiEl = document.createElement('span');
          emojiEl.className = 'hinalya-finder__result-emoji';
          emojiEl.setAttribute('aria-hidden', 'true');
          emojiEl.textContent = result.emoji;
          resultEl.appendChild(emojiEl);
        }

        var titleEl = document.createElement('h3');
        titleEl.className = 'hinalya-finder__result-title';
        titleEl.textContent = result.title;
        resultEl.appendChild(titleEl);

        if (result.text) {
          var textEl = document.createElement('p');
          textEl.className = 'hinalya-finder__result-text';
          textEl.textContent = result.text;
          resultEl.appendChild(textEl);
        }

        var ctas = document.createElement('div');
        ctas.className = 'hinalya-finder__result-ctas';

        if (result.ctaPrimaryUrl && result.ctaPrimaryText) {
          var ctaPrimary = document.createElement('a');
          ctaPrimary.className = 'hinalya-finder__cta hinalya-finder__cta--primary';
          ctaPrimary.href = result.ctaPrimaryUrl;
          ctaPrimary.textContent = result.ctaPrimaryText;
          ctas.appendChild(ctaPrimary);
        }
        if (result.ctaSecondaryUrl && result.ctaSecondaryText) {
          var ctaSecondary = document.createElement('a');
          ctaSecondary.className = 'hinalya-finder__cta hinalya-finder__cta--secondary';
          ctaSecondary.href = result.ctaSecondaryUrl;
          ctaSecondary.textContent = result.ctaSecondaryText;
          ctas.appendChild(ctaSecondary);
        }
        resultEl.appendChild(ctas);

        if (reduceMotionOK()) retrigger(resultEl);
        showPanel('result');
        focusHeading(titleEl);
      }

      if (startBtn) {
        startBtn.addEventListener('click', function () {
          goToQ1(false);
        });
      }
      if (backBtn) {
        backBtn.addEventListener('click', goBack);
      }
      if (restartBtn) {
        restartBtn.addEventListener('click', function () {
          goToQ1(false);
        });
      }
    }

    function initAll() {
      var roots = document.querySelectorAll('[data-hinalya-finder]');
      roots.forEach(function (root) {
        initFinder(root);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["16avisclients"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function reduceMotionOK() {
      return !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    }

    function initNav(root) {
      var viewport = root.querySelector('[data-hr-viewport]');
      var track = root.querySelector('[data-hr-track]');
      var nav = root.querySelector('[data-hr-nav]');
      var prevBtn = root.querySelector('[data-hr-prev]');
      var nextBtn = root.querySelector('[data-hr-next]');
      if (!viewport || !track || !nav) return;

      function isGrid() {
        return root.classList.contains('hinalya-reviews--grid') &&
          window.matchMedia('(min-width: 750px)').matches;
      }

      function update() {
        if (isGrid()) {
          nav.hidden = true;
          return;
        }
        var overflow = track.scrollWidth > viewport.clientWidth + 2;
        nav.hidden = !overflow;
        if (!overflow) return;
        if (prevBtn) prevBtn.disabled = viewport.scrollLeft <= 2;
        if (nextBtn) {
          nextBtn.disabled = viewport.scrollLeft + viewport.clientWidth >= track.scrollWidth - 2;
        }
      }

      function scrollByCard(direction) {
        var slide = track.querySelector('[data-hr-slide]');
        if (!slide) return;
        var styles = window.getComputedStyle(track);
        var gap = parseFloat(styles.columnGap || styles.gap) || 0;
        var amount = (slide.getBoundingClientRect().width + gap) * direction;
        viewport.scrollBy({ left: amount, behavior: reduceMotionOK() ? 'smooth' : 'auto' });
      }

      if (prevBtn) prevBtn.addEventListener('click', function () { scrollByCard(-1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { scrollByCard(1); });

      viewport.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    }

    function initVideos(root) {
      var buttons = root.querySelectorAll('[data-hr-play]');
      buttons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var media = btn.closest('.hinalya-reviews__media');
          if (!media) return;
          var wrap = media.querySelector('[data-hr-video-wrap]');
          var poster = media.querySelector('[data-hr-poster]');
          if (!wrap) return;

          var host = wrap.getAttribute('data-video-host');
          var videoId = wrap.getAttribute('data-video-id');
          if (host && videoId && !wrap.hasChildNodes()) {
            var iframe = document.createElement('iframe');
            iframe.allow = 'accelerometer; encrypted-media; picture-in-picture';
            iframe.allowFullscreen = true;
            iframe.title = 'Témoignage vidéo';
            if (host === 'youtube') {
              iframe.src = 'https://www.youtube.com/embed/' + videoId + '?autoplay=1&playsinline=1';
            } else if (host === 'vimeo') {
              iframe.src = 'https://player.vimeo.com/video/' + videoId + '?autoplay=1';
            }
            wrap.appendChild(iframe);
          }

          wrap.hidden = false;
          btn.hidden = true;
          if (poster) poster.hidden = true;

          var nativeVideo = wrap.querySelector('video');
          if (nativeVideo) {
            nativeVideo.muted = false;
            var playPromise = nativeVideo.play();
            if (playPromise && playPromise.catch) playPromise.catch(function () {});
          }

          var focusTarget = wrap.querySelector('video, iframe');
          if (focusTarget && focusTarget.focus) {
            try { focusTarget.focus(); } catch (e) {}
          }
        });
      });
    }

    function initAll() {
      var roots = document.querySelectorAll('[data-hinalya-reviews]');
      roots.forEach(function (root) {
        initNav(root);
        initVideos(root);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["17produitsphare"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initFeatured(root) {
      var productAvailable = root.getAttribute('data-product-available') === 'true';
      if (!productAvailable) return;

      var variantButtons = Array.prototype.slice.call(root.querySelectorAll('[data-hf-variant]'));
      var ctaButtons = Array.prototype.slice.call(root.querySelectorAll('[data-hf-cta], [data-hf-sticky-cta]'));
      var errorEl = root.querySelector('[data-hf-error]');
      var stockEl = root.querySelector('[data-hf-stock]');
      var productLinkEl = root.querySelector('[data-hf-product-link]');
      var stickyBar = root.querySelector('[data-hf-sticky]');
      var stickyPriceEl = root.querySelector('[data-hf-sticky-price]');

      var isSubmitting = false;
      var resetTimer = null;

      function currentButton() {
        return ctaButtons.length ? ctaButtons[0] : null;
      }

      function readState() {
        var btn = currentButton();
        if (!btn) return { variantId: null, price: '', available: false };
        return {
          variantId: btn.getAttribute('data-variant-id'),
          price: '',
          available: !btn.disabled
        };
      }

      function selectVariant(target) {
        variantButtons.forEach(function (b) {
          var selected = b === target;
          b.setAttribute('aria-checked', selected ? 'true' : 'false');
          b.classList.toggle('is-selected', selected);
        });

        var variantId = target.getAttribute('data-variant-id');
        var price = target.getAttribute('data-price-formatted');
        var available = target.getAttribute('data-available') === 'true';

        ctaButtons.forEach(function (btn) {
          btn.setAttribute('data-variant-id', variantId);
          setNormalLabel(btn, available, price);
        });

        if (stockEl) {
          stockEl.innerHTML = available
            ? '<span class="hinalya-featured__stock-dot hinalya-featured__stock-dot--in"></span> En stock'
            : '<span class="hinalya-featured__stock-dot hinalya-featured__stock-dot--out"></span> Épuisé';
        }

        if (productLinkEl && !productLinkEl.hasAttribute('data-hf-custom-link')) {
          var baseUrl = productLinkEl.getAttribute('data-base-url');
          if (baseUrl) {
            productLinkEl.setAttribute('href', baseUrl + '?variant=' + encodeURIComponent(variantId));
          }
        }

        if (stickyPriceEl) stickyPriceEl.textContent = price;
      }

      function setNormalLabel(btn, available, price) {
        if (!available) {
          btn.disabled = true;
          btn.textContent = btn.getAttribute('data-unavailable-text');
          return;
        }
        btn.disabled = false;
        var priceToUse = price || btn.getAttribute('data-price-formatted') || '';
        btn.textContent = btn.getAttribute('data-cta-text') + ' — ' + priceToUse;
      }

      function setLoading(loading) {
        ctaButtons.forEach(function (btn) {
          btn.disabled = loading;
          btn.setAttribute('aria-busy', loading ? 'true' : 'false');
          if (loading) btn.textContent = btn.getAttribute('data-adding-text');
        });
      }

      function setSuccess() {
        ctaButtons.forEach(function (btn) {
          btn.textContent = btn.getAttribute('data-added-text');
          btn.disabled = false;
        });
        if (resetTimer) clearTimeout(resetTimer);
        resetTimer = setTimeout(function () {
          var selected = root.querySelector('[data-hf-variant].is-selected');
          if (selected) {
            var price = selected.getAttribute('data-price-formatted');
            var available = selected.getAttribute('data-available') === 'true';
            ctaButtons.forEach(function (btn) { setNormalLabel(btn, available, price); });
          } else {
            ctaButtons.forEach(function (btn) {
              setNormalLabel(btn, btn.getAttribute('data-available') !== 'false', btn.getAttribute('data-price-formatted'));
            });
          }
        }, 2200);
      }

      function showError(message) {
        if (!errorEl) return;
        errorEl.textContent = message;
        errorEl.hidden = false;
      }
      function hideError() {
        if (!errorEl) return;
        errorEl.hidden = true;
      }

      // ---- INTÉGRATION PANIER DU THÈME (natif) ----
      // Le produit est déjà réellement ajouté au panier Shopify via
      // /cart/add.js avant que cette fonction soit appelée. On informe
      // ENSUITE les composants natifs du thème (pastille du panier dans le
      // header + tiroir panier <cart-drawer-component>) via le SEUL
      // évènement qu'ils écoutent réellement : 'cart:update', dispatché
      // sur document. Le tiroir panier possède l'attribut "auto-open" et
      // s'ouvre automatiquement dès qu'il reçoit cet évènement.
      function notifyThemeCart(quantityAdded, addedItem) {
        try {
          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: addedItem || {},
              sourceId: 'hinalya-produit-phare',
              data: {
                source: 'product-form-component',
                itemCount: quantityAdded,
                sections: (addedItem && addedItem.sections) || {}
              }
            }
          }));
        } catch (e) {
          // Silencieux : le produit reste ajouté au panier même si
          // la mise à jour de l'UI échoue.
        }
      }

      function addToCart() {
        if (isSubmitting) return;
        var btn = currentButton();
        if (!btn || btn.disabled) return;
        var variantId = btn.getAttribute('data-variant-id');
        if (!variantId) return;

        isSubmitting = true;
        hideError();
        setLoading(true);

        var addedQuantity = 1;
        var cartItemsComponents = document.querySelectorAll('cart-items-component');
        var sectionIds = [];
        cartItemsComponents.forEach(function (item) {
          if (item && item.dataset && item.dataset.sectionId) {
            sectionIds.push(item.dataset.sectionId);
          }
        });

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{ id: variantId, quantity: addedQuantity }],
            sections: sectionIds.join(',')
          })
        })
          .then(function (res) {
            return res.json().then(function (data) {
              if (!res.ok) { throw data; }
              return data;
            });
          })
          .then(function (addedItem) {
            setSuccess();
            notifyThemeCart(addedQuantity, addedItem);
          })
          .catch(function (err) {
            var message = (err && (err.description || err.message)) || 'Une erreur est survenue. Merci de réessayer.';
            showError(message);
            var selected = root.querySelector('[data-hf-variant].is-selected');
            var price = selected ? selected.getAttribute('data-price-formatted') : btn.getAttribute('data-price-formatted');
            var available = selected ? selected.getAttribute('data-available') === 'true' : true;
            ctaButtons.forEach(function (b) { setNormalLabel(b, available, price); });
          })
          .then(function () {
            isSubmitting = false;
          });
      }

      variantButtons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (btn.disabled) return;
          selectVariant(btn);
        });
      });

      ctaButtons.forEach(function (btn) {
        btn.addEventListener('click', addToCart);
      });

      if (stickyBar) {
        var mainCta = root.querySelector('[data-hf-cta]');
        if (mainCta && 'IntersectionObserver' in window) {
          var sectionVisible = false;
          var ctaVisible = true;

          var sectionObserver = new IntersectionObserver(function (entries) {
            sectionVisible = entries[0].isIntersecting;
            updateSticky();
          }, { threshold: 0 });
          sectionObserver.observe(root);

          var ctaObserver = new IntersectionObserver(function (entries) {
            ctaVisible = entries[0].isIntersecting;
            updateSticky();
          }, { threshold: 0 });
          ctaObserver.observe(mainCta);

          function updateSticky() {
            var shouldShow = sectionVisible && !ctaVisible;
            stickyBar.hidden = !shouldShow;
            stickyBar.classList.toggle('is-visible', shouldShow);
          }
        }
      }
    }

    function initAll() {
      var roots = document.querySelectorAll('[data-hinalya-featured]');
      roots.forEach(function (root) { initFeatured(root); });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["18avisexperts"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initPress(root) {
      var revealEnabled = root.getAttribute('data-scroll-reveal') === 'true';
      var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (!revealEnabled || prefersReducedMotion || !('IntersectionObserver' in window)) {
        return;
      }

      var cards = Array.prototype.slice.call(root.querySelectorAll('[data-hp-card]'));
      if (!cards.length) return;

      cards.forEach(function (card) {
        card.classList.add('hinalya-press__reveal-ready');
      });

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
      );

      cards.forEach(function (card) {
        observer.observe(card);
      });
    }

    function initAll() {
      var roots = document.querySelectorAll('[data-hinalya-press]');
      roots.forEach(function (root) { initPress(root); });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["20carrousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initBestsellers(root) {
      var track = root.querySelector('[data-hbs-track]');
      var prevBtn = root.querySelector('[data-hbs-prev]');
      var nextBtn = root.querySelector('[data-hbs-next]');
      if (!track || !prevBtn || !nextBtn) return;

      var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function updateArrows() {
        var hasOverflow = track.scrollWidth > track.clientWidth + 2;
        var isDesktop = window.innerWidth >= 990;
        var shouldShow = hasOverflow && isDesktop;

        prevBtn.hidden = !shouldShow;
        nextBtn.hidden = !shouldShow;

        if (!shouldShow) return;

        var atStart = track.scrollLeft <= 2;
        var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;

        prevBtn.disabled = atStart;
        prevBtn.setAttribute('aria-disabled', atStart ? 'true' : 'false');
        nextBtn.disabled = atEnd;
        nextBtn.setAttribute('aria-disabled', atEnd ? 'true' : 'false');
      }

      function scrollByPage(direction) {
        track.scrollBy({
          left: direction * track.clientWidth,
          behavior: prefersReducedMotion ? 'auto' : 'smooth'
        });
      }

      prevBtn.addEventListener('click', function () { scrollByPage(-1); });
      nextBtn.addEventListener('click', function () { scrollByPage(1); });

      var scrollTimer = null;
      track.addEventListener('scroll', function () {
        if (scrollTimer) window.clearTimeout(scrollTimer);
        scrollTimer = window.setTimeout(updateArrows, 60);
      }, { passive: true });

      var resizeTimer = null;
      window.addEventListener('resize', function () {
        if (resizeTimer) window.clearTimeout(resizeTimer);
        resizeTimer = window.setTimeout(updateArrows, 150);
      });

      updateArrows();
    }

    function initAll() {
      var roots = document.querySelectorAll('[data-hinalya-bestsellers]');
      roots.forEach(function (root) { initBestsellers(root); });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["21Faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initFaq(root) {
      var allowMultiple = root.getAttribute('data-allow-multiple') === 'true';
      var items = Array.prototype.slice.call(root.querySelectorAll('[data-faq-item]'));

      items.forEach(function (item) {
        var trigger = item.querySelector('[data-faq-trigger]');
        var panelWrap = item.querySelector('[data-faq-panel-wrap]');
        if (!trigger || !panelWrap) return;

        trigger.addEventListener('click', function () {
          var isOpen = trigger.getAttribute('aria-expanded') === 'true';

          if (!allowMultiple && !isOpen) {
            items.forEach(function (other) {
              if (other === item) return;
              var otherTrigger = other.querySelector('[data-faq-trigger]');
              var otherWrap = other.querySelector('[data-faq-panel-wrap]');
              if (otherTrigger) otherTrigger.setAttribute('aria-expanded', 'false');
              if (otherWrap) otherWrap.classList.remove('is-open');
            });
          }

          trigger.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
          panelWrap.classList.toggle('is-open', !isOpen);
        });
      });
    }

    function initAll() {
      var roots = document.querySelectorAll('[data-hinalya-faq]');
      roots.forEach(function (root) { initFaq(root); });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["22Footer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initFooterAccordion(root) {
      if (root.getAttribute('data-mobile-accordion') !== 'true') return;

      var triggers = root.querySelectorAll('[data-footer-nav-trigger]');
      triggers.forEach(function (trigger) {
        var panelWrap = trigger.closest('[data-footer-nav-col]').querySelector('[data-footer-nav-panel]');
        if (!panelWrap) return;

        trigger.addEventListener('click', function () {
          var isMobile = window.matchMedia('(max-width: 749px)').matches;
          if (!isMobile) return;

          var isOpen = trigger.getAttribute('aria-expanded') === 'true';
          trigger.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
          panelWrap.classList.toggle('is-open', !isOpen);
        });
      });
    }

    function initAll() {
      var roots = document.querySelectorAll('[data-hinalya-footer]');
      roots.forEach(function (root) { initFooterAccordion(root); });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
